module.exports = __webpack_public_path__ + "img/tracing.e8b2707e.jpg";